module.exports = __webpack_public_path__ + "img/public/siteImages/mailIcon.svg?7e57dc9f";